import $ from 'jquery';
import DataTable from 'datatables.net';
import dataTableLanguageFR from 'datatables.net-plugins/i18n/fr-FR';
import lang from '../lang';
import { createIcons, icons } from 'lucide';

const allLocales = {
    fr: dataTableLanguageFR,
};

DataTable.defaults.language = allLocales[lang];

$(document).on('xhr.dt', function (event, settings) {
    const api = new DataTable.Api(settings);

    api.$('[data-bs-toggle=tooltip]').tooltip('dispose');
});

$(document).on('draw.dt', function (event, settings) {
    const api = new DataTable.Api(settings);

    if (api.ajax.params()) {
        createIcons({icons});
        api.$('[data-bs-toggle=tooltip]').tooltip();
    }
});
